import React, { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import useApi from 'src/hooks/useApi'
import useAuth from 'src/hooks/useAuth'
import { Container, Typography, Button, Box, CircularProgress } from '@material-ui/core'

const SiteContext = React.createContext(null)

export function SiteProvider({ children }) {
  const api = useApi()
  const { logout, user } = useAuth()
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  const site = useSelector((state) => {
    return state.api.site
  })

  useEffect(() => {
    let mounted = true
    
    if (user && !site) {
      setLoading(true)
      api.getSite((res) => {
        if (mounted) {
          if (!res) {
            setError(true)
          } else {
            setError(false)
          }
          setLoading(false)
        }
      })
    } else if (!user) {
      if (mounted) {
        setError(false)
        setLoading(false)
      }
    }

    return () => {
      mounted = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  useEffect(() => {
    if (site && !api.energy) {
      api.getEnergyLogs()
      api.getPowerLogs()
      api.listYeasts()
    }
    if (site && site.integrations?.amberConfig && (!api.amberSites || api.amberSites.length === 0)) {
      api.listAmberSites()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [site])

  // If there's no user logged in, bypass the site check so the login page can render
  if (!user) {
    return <SiteContext.Provider value={site}>{children}</SiteContext.Provider>
  }

  if (loading && !site) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    )
  }

  if (error && !site) {
    return (
      <Container maxWidth="sm" style={{ marginTop: '100px', textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>
          No Site Associated
        </Typography>
        <Typography variant="body1" color="textSecondary" paragraph>
          Your account is not associated with any site. Please contact your account administrator to be invited to a site.
        </Typography>
        <Button variant="contained" color="primary" onClick={() => {
          logout(() => history.push('/'))
        }}>
          Sign Out
        </Button>
      </Container>
    )
  }

  return <SiteContext.Provider value={site}>{children}</SiteContext.Provider>
}

export function useSiteContext() {
  const context = useContext(SiteContext)

  if (!context) {
    throw new Error('No SiteProvider was found.')
  }

  return context
}

